var _defs, _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconConfig = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.999,
    height: 16.002,
    viewBox: "0 0 15.999 16.002",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8798ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1879 -1282.998)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-5977.732-13443H-5987a1,1,0,0,1-1-1,1,1,0,0,1,1-1h9.268a2,2,0,0,1,1.732-1,2,2,0,0,1,1.733,1H-5973a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-1.267a2,2,0,0,1-1.733,1A2,2,0,0,1-5977.732-13443Zm-4-6H-5987a1,1,0,0,1-1-1,1,1,0,0,1,1-1h5.269a1.993,1.993,0,0,1,1.729-1,1.994,1.994,0,0,1,1.732,1H-5973a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-5.266a2.005,2.005,0,0,1-1.736,1A2,2,0,0,1-5981.734-13449Zm-4-6H-5987a1,1,0,0,1-1-1,1,1,0,0,1,1-1h1.27a2,2,0,0,1,1.729-1,2,2,0,0,1,1.729,1H-5973a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-9.268a2,2,0,0,1-1.732,1A2,2,0,0,1-5985.733-13455Z",
    transform: "translate(7867 14740.999)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconConfig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-config.b63d045d.svg";
export { ForwardRef as ReactComponent };